import type { IconData } from '@stacksjs/iconify-core'

export const target3Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 24C.5 36.979 11.021 47.5 24 47.5S47.5 36.979 47.5 24S36.979.5 24 .5S.5 11.021.5 24m39.377-1.996c-.901-7.24-6.64-12.98-13.881-13.88q.004.062.004.126v5a2 2 0 1 1-4 0v-5q0-.064.004-.127c-7.24.901-12.98 6.64-13.88 13.881L8.25 22h5a2 2 0 1 1 0 4h-5a2 2 0 0 1-.127-.004c.901 7.24 6.64 12.98 13.88 13.88L22 39.75v-5a2 2 0 1 1 4 0v5q0 .064-.004.127c7.24-.901 12.98-6.64 13.88-13.881L39.75 26h-5a2 2 0 1 1 0-4h5q.064 0 .127.004M18 24a2 2 0 0 0 2 2h2v2a2 2 0 1 0 4 0v-2h2a2 2 0 1 0 0-4h-2v-2a2 2 0 1 0-4 0v2h-2a2 2 0 0 0-2 2\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default target3Remix
